import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn's `cn`. Also exported as `cx` — the mockups use that name. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export const cx = cn
